import { Select } from '@base-ui/react/select';
import type { ISelectionOption } from '@components/Pages/AnalyticsPage/analytics.types';
import chevronDownSvg from '@assets/analytics/chevron-down.svg?raw';
import { ScrollArea } from '@components/ui/ScrollArea/ScrollArea';
import styles from './SingleSelect.module.css';

interface ISingleSelectProps {
  value: string | null;
  onChange: (next: string) => void;
  options: ISelectionOption[];
  placeholder: string;
  ariaLabel: string;
  disabled?: boolean;
  /** Lift the popup above dialog/drawer surfaces (z-dialog). Opt-in so
      page-level selects keep their default, lower stacking context. */
  elevated?: boolean;
}

export function SingleSelect({ value, onChange, options, placeholder, ariaLabel, disabled, elevated }: ISingleSelectProps) {
  const selected = options.find((o) => o.id === value) ?? null;
  return (
    <Select.Root
      value={value ?? ''}
      onValueChange={(next) => { if (next) onChange(next); }}
      disabled={disabled}
    >
      <Select.Trigger aria-label={ariaLabel} className={styles.trigger}>
        <Select.Value className={styles.value}>
          {selected ? selected.label : <span className={styles.placeholder}>{placeholder}</span>}
        </Select.Value>
        <Select.Icon className={styles.icon}>
          <span aria-hidden="true" dangerouslySetInnerHTML={{ __html: chevronDownSvg }} />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Positioner
          sideOffset={4}
          alignItemWithTrigger={false}
          className={elevated ? styles.positioner : undefined}
        >
          <Select.Popup className={styles.popup}>
            <ScrollArea>
              {options.map((opt) => (
                <Select.Item key={opt.id} value={opt.id} className={styles.item}>
                  <Select.ItemText>{opt.label}</Select.ItemText>
                </Select.Item>
              ))}
            </ScrollArea>
          </Select.Popup>
        </Select.Positioner>
      </Select.Portal>
    </Select.Root>
  );
}
